import React, { useEffect, useState } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { api } from "../lib/api";
import { useApp } from "../context/AppContext";
import { Link } from "react-router-dom";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

const CENTERS = { Guadeloupe: [16.25, -61.55], Martinique: [14.64, -61.02], Guyane: [4.0, -53.0] };

export default function MapPage() {
  const { territoire } = useApp();
  const [markers, setMarkers] = useState([]);

  useEffect(() => {
    Promise.all([
      api.get("/sites").then((r) => r.data).catch(() => []),
      api.get("/contacts").then((r) => r.data).catch(() => []),
      api.get("/equipment").then((r) => r.data).catch(() => []),
    ]).then(([sites, contacts, equip]) => {
      const m = [];
      sites.filter((s) => s.latitude && s.longitude).forEach((s) =>
        m.push({ id: `s-${s.id}`, lat: s.latitude, lng: s.longitude, label: `${s.numero} — ${s.nom}`, type: "Chantier", link: `/chantiers/${s.id}` }));
      contacts.filter((c) => c.latitude && c.longitude).forEach((c) =>
        m.push({ id: `c-${c.id}`, lat: c.latitude, lng: c.longitude, label: c.raison_sociale, type: c.categorie }));
      equip.filter((e) => e.latitude && e.longitude).forEach((e) =>
        m.push({ id: `e-${e.id}`, lat: e.latitude, lng: e.longitude, label: e.nom, type: `Matériel (${e.disponibilite})` }));
      setMarkers(m);
    });
  }, []);

  const center = CENTERS[territoire] || CENTERS.Guadeloupe;

  return (
    <div className="space-y-4" data-testid="map-page">
      <h1 className="font-display text-3xl font-extrabold uppercase tracking-tight">Cartographie</h1>
      <p className="text-sm text-muted-foreground">
        Chantiers, contacts et matériel géolocalisés. Les nouveaux chantiers enregistrent leur position GPS depuis le formulaire de création.
      </p>
      <div className="h-[60vh] rounded-xl overflow-hidden border-2 border-border" data-testid="map-container">
        <MapContainer key={territoire} center={center} zoom={10} scrollWheelZoom>
          <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
          {markers.map((m) => (
            <Marker key={m.id} position={[m.lat, m.lng]}>
              <Popup>
                <div className="text-sm">
                  <div className="font-bold">{m.label}</div>
                  <div className="text-xs">{m.type}</div>
                  {m.link && <Link to={m.link} className="text-amber-700 font-bold text-xs">Ouvrir la fiche</Link>}
                  <div className="mt-1">
                    <a href={`https://www.openstreetmap.org/directions?to=${m.lat}%2C${m.lng}`} target="_blank" rel="noreferrer"
                      className="text-sky-700 font-bold text-xs">Itinéraire →</a>
                  </div>
                </div>
              </Popup>
            </Marker>
          ))}
        </MapContainer>
      </div>
      <div className="text-xs text-muted-foreground" data-testid="map-count">{markers.length} point(s) géolocalisé(s) — territoire affiché : {territoire}</div>
    </div>
  );
}
